import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';
import { createRoute } from 'lib/util';

const getEmployeesUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/employees`;

const toggleEmployeeUrl = (eId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/employees/${eId}/toggle`;

const addEmployeeUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/employees`;

const updateEmployeeUrl = (eId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/employees/${eId}`;

const getEmployeeByIdUrl = (eId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/employees/${eId}`;

export const getEmployeesReportCSVUrl = (cId, sId) => createRoute(cId, sId, `employees/export`);

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getEmployeesUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(employeeId, companyId, subcompanyId) {
    const url = toggleEmployeeUrl(employeeId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(employeeId, companyId, subcompanyId) {
    const url = getEmployeeByIdUrl(employeeId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(employeeId, companyId, subcompanyId, employee) {
    const url = updateEmployeeUrl(employeeId, companyId, subcompanyId);
    return this.axios
      .put(url, employee, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, employee) {
    const url = addEmployeeUrl(companyId, subcompanyId);
    return this.axios
      .post(url, employee, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getEmployeesReportCSV(companyId, subcompanyId, filters) {
    const url = getEmployeesReportCSVUrl(companyId, subcompanyId);
    const params = { ...filters };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/employees.api.js